var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ErrorBase, PlayerError } from '../base/error';
import { MediaElementNativeDetail, MediaElementNetworkErrorCode, MediaElementPlaybackErrorCode, } from '../base/error/constants';
import { getSupportedKeySystemConfig, KeySystems } from '../drm';
import { HDR_CAPABILITY } from '../enums';
import { i18nConfig } from '../i18n';
import commonTool from './comtool';
import domTool from './dom';
import { t } from './i18n-tool';
import uaTool from './uatool';
var testVideoElement = document.createElement('video');
var wasmDetectionCache = null;
var videoTool = {
    getBuffered: function (video) {
        var buffered = [];
        var len = video.buffered.length;
        for (var i = 0; i < len; i++) {
            buffered.push({
                start: video.buffered.start(i),
                end: video.buffered.end(i),
            });
        }
        return buffered;
    },
    /**
     * 检查时间是否在video已经缓冲的buffer范围内
     * @param {number} time 相对于整个video标签的时间
     */
    checkTimeInBuffer: function (time, buffered) {
        var ret = false;
        var len = buffered.length;
        for (var i = 0; i < len; i++) {
            var sr = buffered[i].start;
            var er = buffered[i].end;
            if (time >= sr && time <= er) {
                ret = true;
                break;
            }
        }
        return ret;
    },
    clear: function (video) {
        if (!video) {
            return;
        }
        if (video instanceof HTMLVideoElement) {
            // 如果是真video标签，移除src属性。
            // 注意：video标签不能设置src=null再调用load，否则会产生一个类似http://xxx/null的请求。
            video.removeAttribute('src');
            // 如果像 webrtc 这样是通过设置 srcObject 来播放的源，则一并清除掉
            video.srcObject = null;
        }
        else {
            // 某些内核的video组件非HTMLVideoElement
            video.srcConfig = null;
            video.src = null;
        }
        video.load();
    },
    destroyElement: function (video) {
        var _a;
        if (!video) {
            return;
        }
        // 有扩展destroy接口的IVideoElement对象，调用一下destroy方法
        (_a = video.destroy) === null || _a === void 0 ? void 0 : _a.call(video);
        videoTool.clear(video);
        videoTool.removeElement(video, null);
    },
    /**
     * 使用 Canvas 进行视频截图，并返回截图信息
     */
    captureVideo: function (video, config) {
        var dx = config.dx, dy = config.dy, dw = config.dw, dh = config.dh;
        var videoWidth = video.videoWidth, videoHeight = video.videoHeight;
        var canvas = document.createElement('canvas');
        canvas.width = videoWidth;
        canvas.height = videoHeight;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, videoWidth, videoHeight);
        return {
            captureHeight: dh,
            captureWidth: dw,
            captureX: dx,
            captureY: dy,
            playtime: video.currentTime,
            data: ctx.getImageData(dx, dy, dw, dh),
        };
    },
    resizeElement: function (video, value) {
        var _a;
        if (!value || !video) {
            return;
        }
        if (video instanceof HTMLElement) {
            domTool.css(video, value);
        }
        else {
            var width = value.width, height = value.height;
            if (typeof width === 'number' && typeof height === 'number') {
                // 可能是模拟video标签的组件，例如electron内核使用的video标签
                (_a = video.resize) === null || _a === void 0 ? void 0 : _a.call(video, width, height);
            }
        }
    },
    appendElement: function (video, container) {
        var _a;
        if (video instanceof HTMLElement) {
            domTool.append(container, video);
        }
        else {
            // 可能是模拟video标签的组件，例如electron内核使用的video标签
            (_a = video.appendToParent) === null || _a === void 0 ? void 0 : _a.call(video, container);
        }
    },
    removeElement: function (video, container) {
        var _a;
        if (video instanceof HTMLElement) {
            if (video === null || video === void 0 ? void 0 : video.parentNode) {
                video.remove();
            }
        }
        else {
            // 可能是模拟video标签的组件，例如electron内核使用的video标签
            (_a = video.removeFromParent) === null || _a === void 0 ? void 0 : _a.call(video, container);
        }
    },
    /**
     * 设置video组件的object-fit属性类型
     * @param el video元素
     * @param type 填充类型
     */
    setElementFitType: function (el, type) {
        if (el && el instanceof HTMLElement) {
            domTool.css(el, { 'object-fit': type });
        }
    },
    /**
     * 缓冲数据的最大时长
     */
    getDefaultMaxBufferTime: function () {
        var connection = navigator.connection;
        if (connection && connection.type === 'wifi') {
            return 180;
        }
        if (connection && connection.type === '4g') {
            return 120;
        }
        return 180;
    },
    /**
     * 是否是自动播放被阻止的标识
     * @param errorMsg video标签play时catch到的异常信息
     */
    isAutoPlayBlockedMessage: function (errorMsg) {
        // 自动播放被阻止的信息name和message
        // chrome: NotAllowedError, play() failed because the user didn't interact with the document first.
        // safari/ios: NotAllowedError, The request is not allowed by the user agent or the platform in the current
        //             context, possibly because the user denied permission.
        // x5: NotAllowedError, play() can only be initiated by a user gesture.
        return errorMsg && /interact|not allowed|user gesture/.test(errorMsg);
    },
    /**
     * 是否支持两个或以上video标签同时播放视频。
     */
    supportSameTimePlay: function () {
        // x5的最新64位版本不支持多video同时播放
        if (uaTool.browser.x5 && ['45031', '45032'].indexOf("".concat(uaTool.browser.x5.version)) !== -1) {
            return false;
        }
        // 移动端qq浏览器
        if (uaTool.browser.mqqbrowser && !(uaTool.browser.qqlive || uaTool.browser.wechat || uaTool.browser.mqq)) {
            return false;
        }
        // ios9: 无法用js代码将视频静音（volume =0 或者muted），即使用物理键将手机静音，也无法两个视频同时播放
        // 包括ios11以下
        if (uaTool.os.ios && uaTool.os.version && commonTool.compareVersion(uaTool.os.version, '11.0') < 0) {
            return false;
        }
        return true;
    },
    /**
     * 目前发现低版本x5使用的webview(chrome57)无法检测到自动播放，即video.play()无法catch到被拦截的错误，
     * AudioContext也无法检测。
     */
    cannotDetectAutoPlayBlock: function () {
        return uaTool.browser.chrome && commonTool.compareVersion(uaTool.browser.chrome.version, '66.0') < 0;
    },
    /**
     * 支持#t标准的浏览器（支持指定起播点）
     */
    supportMediaFragmentsURISpec: function (enableMediaFragmentsURI) {
        if (typeof enableMediaFragmentsURI !== 'undefined') {
            return !!enableMediaFragmentsURI;
        }
        if (window.navigator.userAgent.indexOf('jsdom') !== -1) {
            // jsdom环境下不支持
            return false;
        }
        // 目前可以确定支持#t的：基本上桌面所有浏览器、移动端ios
        return !uaTool.mobile || !!uaTool.os.ios;
    },
    getVideoPlaybackQuality: function (video) {
        var totalVideoFrames = 0;
        var droppedVideoFrames = 0;
        if (video === null || video === void 0 ? void 0 : video.getVideoPlaybackQuality) {
            var info = video.getVideoPlaybackQuality();
            droppedVideoFrames = info.droppedVideoFrames || 0;
            totalVideoFrames = info.totalVideoFrames || 0;
        }
        else if (video && video.webkitDecodedFrameCount) {
            totalVideoFrames = video.webkitDecodedFrameCount;
            droppedVideoFrames = video.webkitDroppedFrameCount;
        }
        return { totalVideoFrames: totalVideoFrames, droppedVideoFrames: droppedVideoFrames };
    },
    /**
     * MSE能力检查
     */
    supportMSE: function () {
        var mediaSource = videoTool.getMediaSource();
        if (!mediaSource) {
            return false;
        }
        var sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
        var isTypeSupported = mediaSource
            && typeof mediaSource.isTypeSupported === 'function'
            && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
        // if SourceBuffer is exposed ensure its API is valid
        // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is
        // impossible
        var sourceBufferValidAPI = !sourceBuffer
            || (sourceBuffer.prototype
                && typeof sourceBuffer.prototype.appendBuffer === 'function'
                && typeof sourceBuffer.prototype.remove === 'function');
        return !!isTypeSupported && !!sourceBufferValidAPI;
    },
    /**
     * “粗略的”检查当前环境对主流视频格式的支持情况
     * <br>【注】返回结果只是可能支持，在视频开始播放以后仍然有可能抛出不支持媒体格式的异常。
     */
    supportVideoFormat: function () {
        //  mine类型参考：
        // https://developer.mozilla.org/zh-CN/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
        // https://www.iana.org/assignments/media-types/media-types.xhtml
        var mimetypesKind = {
            mp4: 'video/mp4',
            mov: 'video/mp4',
            hls: 'application/x-mpegURL',
            avi: 'video/x-msvideo',
            mpeg: 'video/mpeg',
            webm: 'video/webm',
            ogg: 'video/ogg',
        };
        var sptFormats = [];
        Object.keys(mimetypesKind).forEach(function (key) {
            var mimetype = mimetypesKind[key];
            var canPlayResult = testVideoElement.canPlayType(mimetype);
            // 'probably': 这种媒体文件似乎是可播放的。
            // 'maybe': 不能告诉你这种媒体文件是否能被播放，直到你尝试播放它。
            if (['maybe', 'probably'].indexOf(canPlayResult) !== -1) {
                sptFormats.push(key);
            }
        });
        return sptFormats;
    },
    /**
     * 判断当前环境是否支持av1编码的视频播放
     */
    supportAV1: function () {
        return videoTool.isMediaSourceTypeSupported('video/mp4;codecs=av01.0.12M.08');
    },
    /**
     * 判断当前环境是否支持hevc编码的视频播放
     */
    supportHevc: function () {
        return videoTool.isMediaSourceTypeSupported('video/mp4;codecs="hvc1.1.6.L120.90"');
    },
    /** 判断当前环境是否支持hevc profile main 10 */
    supportHEVCMain10: function () {
        return videoTool.isMediaSourceTypeSupported('video/mp4;codecs="hvc1.2.4.L120.90"');
    },
    /** 通过video canPlayType接口检测是否原生支持指定mime格式 */
    isVideoCanPlayType: function (mimeType) {
        return testVideoElement.canPlayType(mimeType);
    },
    /** 通过mse isTypeSupported接口检测是否支持指定mime格式 */
    isMediaSourceTypeSupported: function (mimeType) {
        var _a;
        try {
            return (_a = videoTool.getMediaSource()) === null || _a === void 0 ? void 0 : _a.isTypeSupported(mimeType);
        }
        catch (e) {
            return false;
        }
    },
    /**
     * 通过MediaCapabilities接口检测指定mime格式是否支持
     */
    isMediaCapabilitiesTypeSupported: function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var type, mimeType, _a, resolution, _b, bitrate, _c, framerate, mediaConfig, _d, height, width, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        type = config.type, mimeType = config.mimeType, _a = config.resolution, resolution = _a === void 0 ? '860x480' : _a, _b = config.bitrate, bitrate = _b === void 0 ? 800 : _b, _c = config.framerate, framerate = _c === void 0 ? 30 : _c;
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 3, , 4]);
                        mediaConfig = {
                            type: 'media-source',
                        };
                        switch (type) {
                            case 'audio':
                                mediaConfig.audio = {
                                    contentType: mimeType,
                                };
                                break;
                            case 'audio-spatial':
                                mediaConfig.audio = {
                                    contentType: mimeType,
                                    spatialRendering: true,
                                };
                                break;
                            case 'video': {
                                _d = resolution.toLowerCase().split('x'), height = _d[0], width = _d[1];
                                mediaConfig.video = {
                                    contentType: mimeType,
                                    bitrate: bitrate,
                                    framerate: framerate,
                                    height: +height,
                                    width: +width,
                                };
                            }
                            default:
                                break;
                        }
                        return [4 /*yield*/, navigator.mediaCapabilities.decodingInfo(mediaConfig)];
                    case 2: return [2 /*return*/, (_f.sent()).supported];
                    case 3:
                        _e = _f.sent();
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    /**
     * 检测当前显示器是否支持HDR
     * @returns 0 不支持；1 不支持，但为广色域屏幕，可以通过系统级的tone map播放SDR内容；2 支持
     */
    isHDRSupported: function () {
        try {
            if (window.matchMedia('(dynamic-range: high)').matches)
                return HDR_CAPABILITY.SUPPORTED;
            if (window.matchMedia('(color-gamut: p3)').matches)
                return HDR_CAPABILITY.WCG_DISPLAY_BUT_NO_HDR;
            return HDR_CAPABILITY.NOT_SUPPORTED;
        }
        catch (_a) {
            return HDR_CAPABILITY.NOT_SUPPORTED;
        }
    },
    /**
     * 检测当前环境是否支持HEVC-based Dolby Vision格式
     */
    isDolbyVisionSupported: function () {
        return videoTool.isMediaSourceTypeSupported('video/mp4; codecs="dvhe"');
    },
    /**
     * 检测当前环境是否支持Dolby Atmos格式
     */
    isDolbyAtomsSupported: function (spatial) {
        if (spatial === void 0) { spatial = false; }
        return videoTool.isMediaSourceTypeSupported('audio/mp4; codecs="ec-3"');
    },
    getMediaSource: function () {
        if (typeof window !== 'undefined') {
            return window.MediaSource || window.WebKitMediaSource;
        }
    },
    /** 判断当前环境是否支持特定的EME配置 */
    isEncryptionSupported: function (keySystem, configuration) {
        return __awaiter(this, void 0, void 0, function () {
            var configurationToUse, hasEMESupport, hasCDMSupport, mediaKeySystemAccess, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        configurationToUse = configuration || getSupportedKeySystemConfig(keySystem);
                        hasEMESupport = [window.MediaKeys, window.WebKitMediaKeys].some(function (i) { return i; });
                        if (!hasEMESupport)
                            return [2 /*return*/, false];
                        hasCDMSupport = typeof window.navigator.requestMediaKeySystemAccess !== 'undefined';
                        if (!hasCDMSupport)
                            return [2 /*return*/, false];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, window.navigator.requestMediaKeySystemAccess(keySystem, [configurationToUse])];
                    case 2:
                        mediaKeySystemAccess = _a.sent();
                        return [2 /*return*/, !!mediaKeySystemAccess];
                    case 3:
                        e_1 = _a.sent();
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    /**
     * @deprecated 维持兼容性，推荐使用isEncryptionSupported
     * 判断当前环境是否支持widevine
     */
    supportWidevine: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, videoTool.isEncryptionSupported(KeySystems.Widevine)];
            });
        });
    },
    /** 判断当前环境是否支持fairplay */
    supportFairplay: function () {
        var keySystem = KeySystems.FairPlayWebKit;
        if (!window.WebKitMediaKeys)
            return false;
        var isTypeSupported = window.WebKitMediaKeys.isTypeSupported(keySystem, 'video/mp4');
        return isTypeSupported;
    },
    supportWebGL: function () {
        var canvasElement = document.createElement('canvas');
        var webglContext;
        try {
            webglContext = canvasElement.getContext('webgl');
        }
        catch (e) {
            return false;
        }
        return !!webglContext;
    },
    /**
     * 判断当前环境是否支持WebRTC
     */
    isWebRTCSupported: function () {
        var isIOS = Boolean(uaTool.os.ios);
        var isUC = Boolean(uaTool.browser.uc);
        var isSafari = Boolean(uaTool.browser.safari);
        // android的uc浏览器直接就不支持webrtc，ios的uc浏览器会劫持video标签，导致无法播放视频流
        if (isUC) {
            return false;
        }
        // isIOS的safari 11.1.2以上才支持WebRTC
        if (isIOS && isSafari && commonTool.compareVersion(uaTool.os.version, '11.1.2') < 0) {
            return false;
        }
        // 检查 window 下是否支持对应 API
        return 'RTCPeerConnection' in window || 'webkitRTCPeerConnection' in window;
    },
    isPositionBuffered: function (video, position) {
        var buffered = video.buffered;
        var time = position || video.currentTime;
        for (var i = 0; i < buffered.length; i++) {
            if (time >= buffered.start(i) && time <= buffered.end(i)) {
                return true;
            }
        }
        return false;
    },
    getNextBufferedStart: function (video, position) {
        var buffered = video.buffered;
        var time = position || video.currentTime;
        for (var i = 0; i < buffered.length; i++) {
            if (buffered.start(i) > time) {
                return buffered.start(i);
            }
        }
        return -1;
    },
    getLastBufferedEnd: function (video, position) {
        var buffered = video.buffered;
        var time = position || video.currentTime;
        for (var i = buffered.length - 1; i >= 0; i--) {
            if (buffered.end(i) < time) {
                return buffered.end(i);
            }
        }
        return -1;
    },
    /**
     * 通过webgl检测当前环境是否开启了硬件加速
     */
    isHardwareAccelerated: function () {
        try {
            var canvas = document.createElement('canvas');
            var attributes = {
                alpha: true,
                antialias: false,
                depth: true,
                failIfMajorPerformanceCaveat: true,
                stencil: true,
            };
            return !!(canvas.getContext('webgl', attributes)
                || canvas.getContext('experimental-webgl', attributes));
        }
        catch (_a) {
            return false;
        }
    },
    /**
     * 尝试通过初始化一个空的 wasm 文件，来判断当前环境是否支持 wasm
     */
    isWasmSupported: function () {
        // 如果已经探测过了，返回一个 cache 值
        if (wasmDetectionCache !== null) {
            return wasmDetectionCache;
        }
        // 如果 window 上连 api 都没有，返回 false
        if (!window.WebAssembly) {
            wasmDetectionCache = false;
            return false;
        }
        try {
            // 一个空的 WASM 二进制的 int8 表示
            // 里面只有一个 (module)
            var wasmAbf = Uint8Array.from([0, 97, 115, 109, 1, 0, 0, 0]);
            var wasmModule = new WebAssembly.Module(wasmAbf);
            var wasmInstance = new WebAssembly.Instance(wasmModule);
            // 看看能不能创建成功
            wasmDetectionCache = wasmInstance instanceof WebAssembly.Instance;
        }
        catch (_a) {
            // 如果有异常，则没办法实例化 WASM，则判断不支持
            wasmDetectionCache = false;
        }
        finally {
            return wasmDetectionCache;
        }
    },
    /**
     * 判断当前环境是否支持WASM播放
     */
    isWasmKernelSupported: function () {
        return this.isWasmSupported()
            && !!window.customElements
            && commonTool.supportES6() // wasm内核还需要支持webcomponent、因此也是es6语法
            && videoTool.supportWebGL();
    },
    /**
    * 从各种内核的原始信息中解析出的标准的错误信息
    * @param errorData 各种内核的错误信息
    * @returns  标准化的错误信息
    */
    commonErrorParse: function (errorData) {
        if (errorData instanceof ErrorBase)
            return errorData;
        if (errorData) {
            var code = errorData.code, message = errorData.message;
            return PlayerError.NativeError({
                code: 0 /* UNKNOWN_ERR */,
                detail: code,
                message: message || t(i18nConfig.core.ERROR_MSG_UNKNOWN),
                debugMessage: message,
            });
        }
        return PlayerError.NativeError({
            code: 0 /* UNKNOWN_ERR */,
            message: t(i18nConfig.core.ERROR_MSG_UNKNOWN),
        });
    },
    /**
     * 将 <video /> 标签的抛出的 Error 对象中的 code 状态码转换为对应错误对象
     * 这里因为要考虑 i18n 的可配置，因此不能直接写成枚举，而是要包在函数内以便外部覆盖
     */
    getVideoError: function (videoTag) {
        var _a;
        var code = (_a = videoTag.error) === null || _a === void 0 ? void 0 : _a.code;
        var errorCodeMap = {
            1: 1 /* MEDIA_ERR_ABORTED */,
            2: 2 /* MEDIA_ERR_NETWORK */,
            3: 102 /* MEDIA_ERR_DECODE */,
            4: 103 /* MEDIA_ERR_SRC_NOT_SUPPORTED */,
        };
        var messageMap = {
            1: t(i18nConfig.core.ERROR_MEDIA_ERR_ABORTED),
            2: t(i18nConfig.core.ERROR_MEDIA_ERR_NETWORK),
            3: t(i18nConfig.core.ERROR_MEDIA_ERR_DECODE),
            4: t(i18nConfig.core.ERROR_MEDIA_ERR_SRC_NOT_SUPPORTED),
        };
        var numberCode = +code;
        var message = messageMap[numberCode];
        if (MediaElementNetworkErrorCode.includes(numberCode)) {
            return PlayerError.NetworkError({
                code: errorCodeMap[numberCode],
                fatal: false,
                message: message,
            });
        }
        if (MediaElementPlaybackErrorCode.includes(numberCode)) {
            var detail = 0;
            if (!videoTool.isVideoCanPlayType('video/mp4; codecs="avc1.42E01E"')) {
                detail |= MediaElementNativeDetail.BaselineAVCNotSupported;
            }
            if (!videoTool.isHardwareAccelerated()) {
                detail |= MediaElementNativeDetail.HardwareAcceleratedOff;
            }
            return PlayerError.NativeError({
                code: errorCodeMap[numberCode],
                fatal: false,
                detail: detail,
                message: message,
            });
        }
    },
};
export default videoTool;
